import { Button, Flex, Form, Input, Modal, Switch } from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import { editHobby, IHobbyEdit } from '../../../api/customerHobby/customerHobbyApi'
import { useForm } from 'antd/es/form/Form'

interface Props {
  show: boolean,
  infoCustomerHobby?: IHobbyEdit
  modalClose?: () => void
  onSubmitModalEdit: (isSucces: boolean, errorMessage?: string) => void
}

const EditHobbyModal: React.FC<Props> = (props) => {
  const { show, infoCustomerHobby, modalClose, onSubmitModalEdit } = props
  const [isStatus, setIsStatus] = useState(false)
  const formRef: any = useRef(null)
  const [form] = useForm()

  const onFormFinish = async (value: any) => {
    const { name, code } = value
    const result = await editHobby(Number(infoCustomerHobby?.id), code, name, Number(isStatus))
    if (result.status) {
      onSubmitModalEdit?.(true)
    } else {
      onSubmitModalEdit?.(false, result.message)
    }
  }

  useEffect(() => {
    if (show && infoCustomerHobby) {
      form.setFieldValue('name', infoCustomerHobby?.title)
      form.setFieldValue('code', infoCustomerHobby?.code)

      setIsStatus(!!infoCustomerHobby?.status)
    } else {
      setIsStatus(false)
    }
  }, [show, infoCustomerHobby])
  return (
    <>
      <Modal
        open={show}
        title='Chỉnh sửa sở thích'
        className='rs-modal w-400 footer-content-end add-relative-modal'
        centered
        footer={
          <Button
            type='primary'
            className='rs-button rs-button--sm'
            onClick={() => formRef?.current.submit()}
          >Lưu</Button>
        }
        onCancel={modalClose}
      >
        <Form
          form={form}
          ref={formRef}
          className='rs-form add-relative-form'
          onFinish={onFormFinish}
          requiredMark={false}
        >
          <Form.Item
            layout='vertical'
            label='Mã sở thích'
            name='code'
            rules={[
              { required: true, message: "Vui lòng nhập mã sở thích" }
            ]}
          >
            <Input
              maxLength={8}
              placeholder='Mã sở thích'
              className='rs-input rs-input--32'
            />
          </Form.Item>
          <Form.Item
            layout='vertical'
            label='Tên sở thích'
            name='name'
            rules={[
              { required: true, message: "Vui lòng nhập tên sở thích" }
            ]}
          >
            <Input
              placeholder='Tên sở thích'
              className='rs-input rs-input--32'
            />
          </Form.Item>

          <Form.Item name='status'>
            <Flex className='gap-24px'>
              <span>Sử dụng</span>
              <Switch
                checked={isStatus}
                onChange={() => setIsStatus(!isStatus)}
                className="rs-switch"
              />
            </Flex>
          </Form.Item>
        </Form>
      </Modal>
    </>
  )
}

export default EditHobbyModal
